import {
  FETCH_SUGGESTIONS_REQUEST,
  FETCH_SUGGESTIONS_SUCCESS,
  FETCH_SUGGESTIONS_ERROR,
  UPDATE_SUGGESTION_REQUEST,
  UPDATE_SUGGESTION_SUCCESS,
  UPDATE_SUGGESTION_ERROR,
  RESET_SUGGESTIONS,
  RESET_EDIT_SUGGESTION,
  GET_SUGGESTION_FROM_LIST,
  SAVE_SUGGESTIONS_FILTERS,
  RESET_SUGGESTIONS_FILTERS,
  DELETE_SUGGESTION_REQUEST,
  DELETE_SUGGESTION_SUCCESS,
  DELETE_SUGGESTION_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    error: null,
    isFetching: false,
  },
  get: {
    record: {},
    error: null,
    isFetching: false,
  },
  edit: {
    record: {},
    error: null,
    isUpdating: false,
    updated: false,
    removed: false,
  },
  filters: null,
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_SUGGESTIONS_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case FETCH_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
        },
      }

    case FETCH_SUGGESTIONS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          records: [],
          error: action.payload,
        },
      }

    case UPDATE_SUGGESTION_REQUEST:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: true,
        },
      }

    case UPDATE_SUGGESTION_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: false,
          error: null,
          record: action.payload,
          updated: true,
          removed: false,
        },
      }

    case UPDATE_SUGGESTION_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: false,
          error: action.payload,
          record: {},
          updated: false,
          removed: false,
        },
      }

    case RESET_SUGGESTIONS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          records: [],
          error: null,
        },
      }

    case RESET_EDIT_SUGGESTION:
      return {
        ...state,
        edit: {
          isUpdating: false,
          error: null,
          record: {},
          updated: false,
          removed: false,
        },
      }

    case GET_SUGGESTION_FROM_LIST:
      const { index } = action
      const record = state.list.records[index]

      return {
        ...state,
        get: {
          ...state.get,
          record,
          error: null,
          isFetching: false,
        },
      }

    case SAVE_SUGGESTIONS_FILTERS:
      return {
        ...state,
        filters: action.payload,
      }

    case RESET_SUGGESTIONS_FILTERS:
      return {
        ...state,
        filters: null,
      }

    case DELETE_SUGGESTION_REQUEST:
      return {
        ...state,
      }

    case DELETE_SUGGESTION_SUCCESS:
      return {
        ...state,
        error: null,
      }

    case DELETE_SUGGESTION_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
}

export default record
